import { AvvirEvent } from "type_aliases";
import { ApiOrganizationMember } from "avvir";

export type OrganizationMembersLoadedEvent = AvvirEvent<typeof ORGANIZATION_MEMBERS_LOADED, { firebaseOrganizationId: string, members: ApiOrganizationMember[] }>

export const organizationMembersLoaded = (firebaseOrganizationId: string, members: ApiOrganizationMember[]): OrganizationMembersLoadedEvent => ({
  type: ORGANIZATION_MEMBERS_LOADED,
  payload: {
    firebaseOrganizationId,
    members
  }
});

export const ORGANIZATION_MEMBERS_LOADED = "organization_members_loaded";
